// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jrz3","colBig":"styles_colBig__1BDKb","colSmall":"styles_colSmall__1NoJw","shopifyNameWrapper":"styles_shopifyNameWrapper__Fjwvp"};